module.exports = __webpack_public_path__ + "static/media/device.8f470806.jpg";